import React, { Fragment, useState, useEffect } from 'react'
import queryString from 'query-string';
import { FormControl, InputGroup } from 'react-bootstrap'

import FilterDropdown from './FilterDropdown'

import './style.css'

export default function SearchComponent({ history }) {
  const [searchTerm, setSearchTerm] = useState('')

  const handleSearch = () => {
    const { search, ...searchParams } = queryString.parse(history.location.search)

    searchParams.page = 1;
    
    if (searchTerm) {
      searchParams.search = searchTerm;
    }

    history.replace(`/account/users?${queryString.stringify(searchParams)}`)
  }

  useEffect(() => {
    const queryParams = queryString.parse(history.location.search);

    setSearchTerm(queryParams.search || '');
  }, [history.location.search]);

  return (
    <Fragment>
      <div className="form-group w-25">
        <InputGroup>
          <InputGroup.Prepend className='border-right-0'>
            <InputGroup.Text className='pr-1 search-user-input' >
              <i className="fas fa-search"></i>
            </InputGroup.Text>
          </InputGroup.Prepend>
          <FormControl
            value={searchTerm}
            onChange={ (e) => setSearchTerm(e.target.value) }
            className='border-left-0 search-user-input'
            aria-label="search"
            placeholder="Search User"
            aria-describedby="search-addon1"
          />
        </InputGroup>
      </div>
      <div className="form-group">
        <div className='d-flex'>
          <FilterDropdown history={history} />
          <div onClick={handleSearch} className="btn btn-primary">
            <i className="fas fa-search "></i>&nbsp;Search
          </div>
        </div>
      </div>
    </Fragment>
  )
}
